import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import { TableContainer } from "@mui/material";
import '../../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../../PublicForms/Dialog_alert.js';
import { Navigate } from "react-router-dom";
import Config from "../../PublicForms/Config.js";
import Header from '../../PublicForms/Header.js';
import Navigation_Bar from '../../PublicForms/Navigation_Bar.js';
import { ScrollToTop } from '../../PublicForms/ScrollToTop.js';

export default function Preview_Report(props) {

    const[openNav, setOpenNav] = useState(false);
    const[allPersons , setAllPersons] = useState(false);
    const[all , setAll] = useState(false);
    const[runCityUse, setRunCityUse] = useState(false);
    const[cities, setCities] = useState([]);
    const[cityName, setCityName] = useState("");
    const[showCityTbl, setShowCityTbl] = useState(false);
    const[runProvinceUse, setRunProvinceUse] = useState(true);
    const[provinces, setProvinces] = useState(false);
    const[provinceName, setProvinceName] = useState("");
    const[showTblProvince, setShowTblProvince] = useState(false);
    const[allFilterData, setAllFilterData] = useState([]);
    const[newVersion , setNewVersion] = useState(false);
    const[cost, setCost] = useState();
    const[number, setNumber] = useState();
    const[reportTitle, setReportTitle] = useState("");
    const[printData, setPrintData] = useState([]);
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[showDialog, setShowDialog] = useState(false);
    const[width, setWidth] = useState(0);
    const[provinceID,setProvinceID] = useState();
    const [filteredProvince, setFilteredProvince] = useState([]);
    const [runSetValueData, setRunSetValueData] = useState(false);
    const[runFilterProvince, setRunFilterProvince] = useState(false);
    const[citySearch, setCitySearch] = useState("");
    const [filteredCity, setFilteredCity] = useState([]);
    const[runFilterCity, setRunFilterCity] = useState(false);
    const[provinceSearch, setProvinceSearch] = useState("");
    const[cityID,setCityID] = useState();

    
  
    useEffect(() => {
      function handleResize() {
        setWidth(window.innerWidth)
      }
      
      window.addEventListener("resize", handleResize)
      
      handleResize()
      
      
    }, []);

 
    const setValueData = (val, indx) =>
    {
     
      var arr = allFilterData;
  
      arr[indx] = val;
  
      setAllFilterData(arr);
       
    }

    const closeOpenDialog = (open) =>
    {
    
      var arr = message;
      arr.splice(0, message.length);
      setMessage(arr);
       setShowDialog(false);
    }  
  

    const handleDB = () =>
    {
      setPrintData([]);
      
      if(allPersons)
      {
          var arr = [];
          
  
        if(allFilterData[0] === undefined  || allFilterData[0] === "" || allFilterData[0] === null)
        {
          arr = allFilterData;
          arr[0] = '-';    
          setAllFilterData(arr);    
            
        }
  
        if(allFilterData[1] === undefined  || allFilterData[1] === "" || allFilterData[1] === null)
        {
          arr = allFilterData;
          arr[1] = '-';
          setAllFilterData(arr);
          
            
        }
  
        if(allFilterData[2] === undefined  || allFilterData[2] === "" || allFilterData[2] === null)
        {
          arr = allFilterData;
          arr[2] = '-';
          setAllFilterData(arr);
            
        }

        window.open(`/printAllPersons/${allFilterData[0]}/${allFilterData[1]}/${allFilterData[2]}`,'_blank', 'rel=noopener noreferrer');

          
      }else if(all)
      {
        var arr = [];
       if(allFilterData[0] === undefined)
      {
        arr = allFilterData;
        arr[0] = '-';  
        setAllFilterData(arr);              
      }

      if(allFilterData[1] === undefined)
      {
        arr = allFilterData;
        arr[1] = '-';  
        setAllFilterData(arr);       
          
      }

      if(allFilterData[2] === undefined)
      {
        arr = allFilterData;
        arr[2] = '-';
        setAllFilterData(arr);
        
          
      }

      if(allFilterData[3] === undefined)
      {
        arr = allFilterData;
        arr[3] = '-';
        setAllFilterData(arr);
        
          
      }
     
      window.open(`/printAllSubscript/${allFilterData[0]}/${allFilterData[1]}/${allFilterData[2]}/${allFilterData[3]}`,'_blank', 'rel=noopener noreferrer');
        
      }else if(newVersion){
        if((reportTitle === undefined || reportTitle === "" || reportTitle === null ) || (cost === undefined || cost === null || cost === "" || parseFloat(cost) < 0 || (number === undefined || number === null || number === "" || parseInt(number) < 0)))
        {
            setMessTitle("توجه");
            setMessage((prevMessages) => {
                return [
                ...prevMessages, // shallow copy into new array reference
                "لطفا مقادیر را به درستی وارد کنید",      // append new element
                ];
            });
            setShowDialog(true);

        }else
        {
          setPrintData((prev) => {
            return [
            ...prev, // shallow copy into new array reference
            reportTitle,      // append new element
            ];
          });
          
          setPrintData((prev) => {
            return [
            ...prev, // shallow copy into new array reference
            cost,      // append new element
            ];
        });
          window.open(`/post/${reportTitle}/${cost}/${number}`,'_blank', 'rel=noopener noreferrer');

          
        }

      }
       
    }
 

    //getProvinces
    useEffect(()=>
      {
        const getProvinces = async ()=>
        {
              axios.get(`${Config.apiBaseUrl}/api/Province`,{headers: {
         
                "Authorization":`Bearer ${localStorage.getItem('token')}`,
              }
            }).then(response => 
              {
                      if(response.status === 200)
                      {
                          setProvinces(response.data);
                          setFilteredProvince(response.data);
                          setRunProvinceUse(false);
                        //  setLoading(false);
                             
                      }else
                      {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              "مجددا تلاش کنید",      // append new element
                          ];
                      });
                       setShowDialog(true);
                      }
          
                  }).catch((err) =>{
          
                    if(err.response !== null && err.response !== undefined)
                      {
                            setMessage([]);
                            if(err.response.status == 401)
                            {
                                Navigate("/login");
                
                
                            }else if((err.response.status)==500)
                            {
                                  setMessTitle("خطا");
                                  setMessage((prevMessages) => {
                                      return [
                                          ...prevMessages, // shallow copy into new array reference
                                          (err.response.detail),      // append new element
                                      ];
                                  });
                                  setShowDialog(true);
                      
                            }else
                            {
                                    setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                          ...prevMessages, // shallow copy into new array reference
                                          "لطفا مجددا تلاش کنید",      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                    
                            }
                
                      }else if(err.message == "Network Error")
                      {
                            setMessTitle("خطا");
                                    setMessage((prevMessages) => {
                                        return [
                                          ...prevMessages, // shallow copy into new array reference
                                          "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                                        ];
                                    });
                                    setShowDialog(true);
                      }else
                      {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    ("لطفا مجددا تلاش کنید"),      // append new element
                                ];
                            });                
                            
                            setShowDialog(true);
                      }
                  });
                
              
                
        };
         
        if(runProvinceUse)
        {
          getProvinces();
          
        }
      
      },[runProvinceUse]);
        
    //getCities
    useEffect(()=>
      {
        const getCities = async ()=>
        {
              axios.get(`${Config.apiBaseUrl}/api/Province/${provinceID}`,{headers: {
         
                "Authorization":`Bearer ${localStorage.getItem('token')}`,
              }
            }).then(response => 
              {
                      if(response.status === 200)
                      {

                          setCities(response.data.cities);
                          setFilteredCity(response.data.cities);
                          if(response.data.cities.length>0)
                          {
                            setShowCityTbl(true);
                          }
                          setRunCityUse(false);
                         // setShowTblProvince(false);
                        //  setLoading(false);
                             
                      }else
                      {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              "مجددا تلاش کنید",      // append new element
                          ];
                      });
                       setShowDialog(true);
                      }
          
                  }).catch((err) =>{

                    if(err.response !== null && err.response !== undefined)
                      {
                          setMessage([]);
                          if(err.response.status === 401)
                          {
                              Navigate("/login");
                          }else if((err.response.status) === 500)
                          {
                              setMessTitle("خطا");
                              setMessage((prevMessages) => {
                                  return [
                                      ...prevMessages, // shallow copy into new array reference
                                      (err.response.detail),      // append new element
                                  ];
                              });
                              setShowDialog(true);
              
                          }else
                          {
                              setMessTitle("خطا");
                              setMessage((prevMessages) => {
                                  return [
                                      ...prevMessages, // shallow copy into new array reference
                                      "لطفا مجددا تلاش کنید",      // append new element
                                  ];
                              });
                              setShowDialog(true);
                  
                          }
              
                      }else if(err.message == "Network Error")
                      {
                          setMessTitle("خطا");
                          setMessage((prevMessages) => {
                              return [
                                  ...prevMessages, // shallow copy into new array reference
                                  "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                              ];
                          });
                          setShowDialog(true);
                      }else
                      {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              ("لطفا مجددا تلاش کنید"),      // append new element
                          ];
                      });                
                      
                      setShowDialog(true);
                      }
          
                  });
                
              
                
        };
         
        if(runCityUse)
        {
          getCities();
          
        }
      
      },[runCityUse]);

      //filter
useEffect(()=>
  {
    if(runFilterProvince)
    {
      
      provinceSearch === '' ?
       setFilteredProvince(provinces)
       :
  
       provinces.map((province)=>
        {
          if(province.provinceName.includes(provinceSearch))
          {
            setFilteredProvince((prev) => {
              return [
                  ...prev, // shallow copy into new array reference
                  (province),      // append new element
              ];
          });
          }
        }
      )
       provinces.filter((province)=>{
         return province.provinceName.includes(provinceSearch)
       })   
       
       setRunFilterProvince(false);
     
    }
    
  
  },[runFilterProvince])
  
  useEffect(()=>
    {
      if(runFilterCity)
      {
        console.log(citySearch)
        citySearch === '' ?
         setFilteredCity(cities)
         :
    
         cities.map((city)=>
          {
            if(city.cityName.includes(citySearch))
            {
              setFilteredCity((prev) => {
                return [
                    ...prev, // shallow copy into new array reference
                    (city),      // append new element
                ];
            });
            }
          }
        )
         cities.filter((city)=>{
           return city.cityName.includes(citySearch)
         })   
         
         setRunFilterCity(false);
       
      }
      
    
    },[runFilterCity])

const setPron = (val)=>
{
  setProvinceName(val);
  setRunSetValueData(true)
}

  const setCityn = (val)=>
  {
    setCityName(val);
    setRunSetValueData(true)
  }

  const handleNave = ()=>
  {
      setOpenNav(!openNav);

  }

  const handleNaveForm = ()=>
    {
      if(!openNav)
        {
          setOpenNav(!openNav)
        }
    }
 
    if(width > 999)
    {
      return (
        <div className='prevPerson'>
         
           <Header />
            <div className="navClass">
                    <Navigation_Bar />
                
            </div>
                
            <div className='prevPersonContainer'>

              <div className='row'>

                <div className='col-md-1'></div>
                   <div className='col-md-11'>
                    
                          <div className='prevPersonForm'>

                            <div className='row'>

                                <div className="col-md-3 checkbox">                      
                                      <label><input type="checkbox"onChange={(e)=> {setAllPersons(e.target.checked); 
                                            setAll(false);
                                            setNewVersion(false);
                                            setAllFilterData([]);
                                            setProvinceName("");
                                            setProvinceID();
                                            setCityName("");
                                        }} checked = {allPersons}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ مشخصات افراد</label> 
                                                          
                                    </div>
                                  <div className="col-md-5 checkbox">                      
                                      <label><input type="checkbox"onChange={(e)=> {setAll(e.target.checked); 
                                            setAllPersons(false);
                                            setNewVersion(false);
                                            setAllFilterData([]);
                                            setProvinceName("");
                                            setProvinceID();
                                            setCityName("");
                                        }} checked = {all}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ مشخصات افراد دارای سابقه اشتراک</label> 
                                                          
                                    </div>
                                  <div className="col-md-4 checkbox">                      
                                    <label><input type="checkbox" onChange={(e)=> {setNewVersion(e.target.checked);
                                        setAllPersons(false);
                                        setAll(false);
                                        setAllFilterData([]);
                                        setProvinceName("");
                                        setProvinceID();
                                        setCityName("");
                                      }} checked = {newVersion} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ سربرگ پست</label> 
                                                        
                                  </div>
                               
                            </div>          
                              

                          </div>
                            {
                              allPersons?
                              <div className='prevPersonForm'>
                                    <div className='row'>

                                        <div className="col-md-4 form-group">
                                            <label htmlFor="degree">تحصیلات</label>
                                            <input type="text" className="form-control" id="degree" value={allFilterData[0]}  onChange={(e)=>setValueData(e.target.value,0)} />
                                        </div>
                                         <div className='col-md-4 form-group'>

                                            <label>استان  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                                                  setRunFilterProvince(true);
                                                  setFilteredProvince([])
                                                }} id="province"  onClick={()=>{
                                                  setShowTblProvince(!showTblProvince);
                                                  setShowCityTbl(false);
                                                
                                                }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                                              <div className='cityValues'>

                                                {
                                                    showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredProvince?.map((province,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                            setValueData(province.provinceName,1);                                                           
                                                            setPron(province.provinceName)
                                                            setCityName("");
                                                            setCitySearch("");
                                                            setProvinceSearch(province.provinceName)
                                                            setProvinceID(province.provinceID);
                                                            setRunCityUse(true);

                                                          }}>
                                                            <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                                            <td >
                                                              {province.provinceName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>
                                        </div>
                                     
                                        <div className='col-md-4 form-group'>

                                            <label>شهر  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" id="city" onChange={(e)=>{setCitySearch(e.target.value)
                                              setRunFilterCity(true)
                                              setFilteredCity([])
                                              }}   
                                              onClick={()=>
                                              {
                                                setRunCityUse(provinceID !== undefined ? true : false);
                                                setShowCityTbl(!showCityTbl);
                                              }} value={cityName} placeholder='جست جوی نام شهر...'/>
                                              <div className='cityValues'>

                                                {
                                                    showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredCity?.map((ct,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                              setValueData(ct.cityName,2);
                                                              setCityID(ct.cityID)
                                                              setCityn(ct.cityName);
                                                              setCityName("");
                                                              setCityName(ct.cityName);


                                                            
                                                          }}>
                                                            <td>{cityID == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                            <td >
                                                              {ct.cityName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>

            
                  
                                        </div>
                                       
                                    </div>
                                    
                              </div>
                            :
                            null

                            }

                            {
                              all?
                              <div className='prevPersonForm'>
                                <div className='row'>
                                    <div className="col-md-6 form-group">
                                            <label htmlFor="remain">اشتراک باقی مانده</label>
                                            <input type="number" className="form-control" id="name" value={allFilterData[0]}  onChange={(e)=>setValueData(e.target.value,0)} 
                                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <label htmlFor="degree">تحصیلات</label>
                                        <input type="text" className="form-control" id="degree" value={allFilterData[1]}  onChange={(e)=>{
                                        
                                          setValueData(e.target.value,1)}} />
                                    </div>
                                    <div className='col-md-6 form-group'>

                                            <label>استان  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                                                  setRunFilterProvince(true);
                                                  setFilteredProvince([])
                                                }} id="province"  onClick={()=>{
                                                  setShowTblProvince(!showTblProvince);
                                                  setShowCityTbl(false);
                                                
                                                }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                                              <div className='cityValues'>

                                                {
                                                    showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredProvince?.map((province,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                            setValueData(province.provinceName,2);                                                           
                                                            setPron(province.provinceName)
                                                            setCityName("");
                                                            setCitySearch("");
                                                            setProvinceSearch(province.provinceName)
                                                            setProvinceID(province.provinceID);
                                                            setRunCityUse(true);

                                                          }}>
                                                            <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                                            <td >
                                                              {province.provinceName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>
                                        </div>
                                     
                                        <div className='col-md-6 form-group'>

                                            <label>شهر  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" id="city" onChange={(e)=>{setCitySearch(e.target.value)
                                              setRunFilterCity(true)
                                              setFilteredCity([])
                                              }}   
                                              onClick={()=>
                                              {
                                                setRunCityUse(provinceID !== undefined ? true : false);
                                                setShowCityTbl(!showCityTbl);
                                              }} value={cityName} placeholder='جست جوی نام شهر...'/>
                                              <div className='cityValues'>

                                                {
                                                    showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredCity?.map((ct,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                              setValueData(ct.cityName,3);
                                                              setCityID(ct.cityID)
                                                              setCityn(ct.cityName);
                                                              setCityName("");
                                                              setCityName(ct.cityName);


                                                            
                                                          }}>
                                                            <td>{cityID == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                            <td >
                                                              {ct.cityName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>

            
                  
                                        </div>

                                </div>
                              </div>
                            :
                            null

                            }

                            {
                                newVersion ? 

                                  <div className='prevPersonForm'>
                                    <div className='row'>
                                        <div className="col-md-6 form-group">
                                                <label htmlFor="duration"> شماره مجله:</label>
                                                <input type="number" className="form-control" id="name" value={reportTitle}  onChange={(e)=>setReportTitle(e.target.value)} 
                                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <label htmlFor="cost"> قیمت هر جلد:</label>
                                            <input type="number" className="form-control" id="cost" value={cost}  onChange={(e)=>setCost(e.target.value)} 
                                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                        </div>
                                        <div className="col-2 form-group">
                                            <label htmlFor="number"> تعداد جلد:</label>
                                            <input type="number" className="form-control" id="number" value={number}  onChange={(e)=>setNumber(e.target.value)} 
                                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                        </div>
                                    </div>
                                  </div>

                                :
                                null
                            }


                            {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                           



                  </div>
                
            </div>

            
                      <div className='row'>
                            
                            <div className='col-md-4'></div>
                            
                            <Button className='col-md-3' onClick={handleDB} autoFocus>
                              چاپ
                            </Button>
                           
                            <div className='col-md-2'></div>

                        </div>
           
        </div>

      </div>
      );
    }else
    {
      return (
        <div className='prevPerson-all-responsive'>
                  <ScrollToTop />

            <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                                

                <Navigation_Bar />
                
            </div>

              <div className='prevPerson'>
                      
                      <Header handleNave={handleNave}/>
                      
                        <div className='prevPersonContainer' onClick={()=>handleNaveForm()}>

                          <div className='row'>

                              <div className='col-md-12'>
                                
                                      <div className='prevPersonForm'>

                                        <div className='row'>

                                            <div className="col-md-3 checkbox">                      
                                                  <label><input type="checkbox"onChange={(e)=> {setAllPersons(e.target.checked); 
                                                        setAll(false);
                                                        setNewVersion(false);
                                                        setAllFilterData([]);
                                                        setProvinceName("");
                                                        setProvinceID();
                                                        setCityName("");
                                                    }} checked = {allPersons}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ مشخصات افراد</label> 
                                                                      
                                                </div>
                                              <div className="col-md-5 checkbox">                      
                                                  <label><input type="checkbox"onChange={(e)=> {setAll(e.target.checked); 
                                                        setAllPersons(false);
                                                        setNewVersion(false);
                                                        setAllFilterData([]);
                                                        setProvinceName("");
                                                        setProvinceID();
                                                        setCityName("");
                                                    }} checked = {all}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ مشخصات افراد دارای سابقه اشتراک</label> 
                                                                      
                                                </div>
                                              <div className="col-md-4 checkbox">                      
                                                <label><input type="checkbox" onChange={(e)=> {setNewVersion(e.target.checked);
                                                    setAllPersons(false);
                                                    setAll(false);
                                                    setAllFilterData([]);
                                                    setProvinceName("");
                                                    setProvinceID();
                                                    setCityName("");
                                                  }} checked = {newVersion} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;چاپ سربرگ پست</label> 
                                                                    
                                              </div>
                                          
                                        </div>          
                                          

                                      </div>
                                        {
                                          allPersons?
                                          <div className='prevPersonForm'>
                                                <div className='row'>

                                                    <div className="col-sm-4 form-group">
                                                        <label htmlFor="degree">تحصیلات</label>
                                                        <input type="text" className="form-control" id="degree" value={allFilterData[0]}  onChange={(e)=>setValueData(e.target.value,0)} />
                                                    </div>
                                                    <div className='col-sm-4 form-group'>

                                                        <label>استان  &#9733;</label>
                                                        <div className='citySearch'>
                                                          <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                                                              setRunFilterProvince(true);
                                                              setFilteredProvince([])
                                                            }} id="province"  onClick={()=>{
                                                              setShowTblProvince(!showTblProvince);
                                                              setShowCityTbl(false);
                                                            
                                                            }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                                                          <div className='cityValues'>

                                                            {
                                                                showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                              <table
                                                                className="table table-condensed"
                                                                style={{ textAlign: "right", padding:'5%' }}
                                                                
                                                              >
                                                                
                                                                <tbody >            
                                                                
                                                                  {filteredProvince?.map((province,index) => {
                                                                    return (
                                                                      <tr key={index} onClick={()=>{
                                                                        setValueData(province.provinceName,1);                                                           
                                                                        setPron(province.provinceName)
                                                                        setCityName("");
                                                                        setCitySearch("");
                                                                        setProvinceSearch(province.provinceName)
                                                                        setProvinceID(province.provinceID);
                                                                        setRunCityUse(true);

                                                                      }}>
                                                                        <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                                                        <td >
                                                                          {province.provinceName}
                                                                        </td>
                                                                        
                                                                      </tr>
                                                                    
                                                                    );
                                                                    })
                                                                  }
                                                                
                                                                </tbody>
                                                              </table> 

                                                            </TableContainer>
                                                            : null
                                                            }
                                                            

                                                          </div>
                                                        </div>
                                                    </div>
                                                
                                                    <div className='col-sm-4 form-group'>

                                                        <label>شهر  &#9733;</label>
                                                        <div className='citySearch'>
                                                          <input type="text" className="form-control" id="city" onChange={(e)=>{setCitySearch(e.target.value)
                                                          setRunFilterCity(true)
                                                          setFilteredCity([])
                                                          }}   
                                                          onClick={()=>
                                                          {
                                                            setRunCityUse(provinceID !== undefined ? true : false);
                                                            setShowCityTbl(!showCityTbl);
                                                          }} value={cityName} placeholder='جست جوی نام شهر...'/>
                                                          <div className='cityValues'>

                                                            {
                                                                showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                              <table
                                                                className="table table-condensed"
                                                                style={{ textAlign: "right", padding:'5%' }}
                                                                
                                                              >
                                                                
                                                                <tbody >            
                                                                
                                                                  {filteredCity?.map((ct,index) => {
                                                                    return (
                                                                      <tr key={index} onClick={()=>{
                                                                          setValueData(ct.cityName,2);
                                                                          setCityID(ct.cityID)
                                                                          setCityn(ct.cityName);
                                                                          setCityName("");
                                                                          setCityName(ct.cityName);


                                                                        
                                                                      }}>
                                                                        <td>{cityID == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                                        <td >
                                                                          {ct.cityName}
                                                                        </td>
                                                                        
                                                                      </tr>
                                                                    
                                                                    );
                                                                    })
                                                                  }
                                                                
                                                                </tbody>
                                                              </table> 

                                                            </TableContainer>
                                                            : null
                                                            }
                                                            

                                                          </div>
                                                        </div>

                        
                              
                                                    </div>
                                                  
                                                </div>
                                                
                                          </div>
                                        :
                                        null

                                        }

                                        {
                                          all?
                                          <div className='prevPersonForm'>
                                            <div className='row'>
                                                <div className="col-sm-6 form-group">
                                                        <label htmlFor="remain">اشتراک باقی مانده</label>
                                                        <input type="number" className="form-control" id="name" value={allFilterData[0]}  onChange={(e)=>setValueData(e.target.value,0)} 
                                                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                                </div>
                                                <div className="col-sm-6 form-group">
                                                    <label htmlFor="degree">تحصیلات</label>
                                                    <input type="text" className="form-control" id="degree" value={allFilterData[1]}  onChange={(e)=>{
                                                    
                                                      setValueData(e.target.value,1)}} />
                                                </div>
                                                <div className='col-sm-6 form-group'>

                                            <label>استان  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" onChange={(e)=>{setProvinceSearch(e.target.value);
                                                  setRunFilterProvince(true);
                                                  setFilteredProvince([])
                                                }} id="province"  onClick={()=>{
                                                  setShowTblProvince(!showTblProvince);
                                                  setShowCityTbl(false);
                                                
                                                }}  defaultValue={provinceSearch} placeholder='جست جوی نام استان...'/>
                                              <div className='cityValues'>

                                                {
                                                    showTblProvince ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredProvince?.map((province,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                            setValueData(province.provinceName,2);                                                           
                                                            setPron(province.provinceName)
                                                            setCityName("");
                                                            setCitySearch("");
                                                            setProvinceSearch(province.provinceName)
                                                            setProvinceID(province.provinceID);
                                                            setRunCityUse(true);

                                                          }}>
                                                            <td>{provinceID == province.provinceID ? <>&#x2713;</>:<></>}</td>
                                                            <td >
                                                              {province.provinceName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>
                                        </div>
                                     
                                        <div className='col-sm-6 form-group'>

                                            <label>شهر  &#9733;</label>
                                            <div className='citySearch'>
                                              <input type="text" className="form-control" id="city" onChange={(e)=>{setCitySearch(e.target.value)
                                              setRunFilterCity(true)
                                              setFilteredCity([])
                                              }}   
                                              onClick={()=>
                                              {
                                                setRunCityUse(provinceID !== undefined ? true : false);
                                                setShowCityTbl(!showCityTbl);
                                              }} value={cityName} placeholder='جست جوی نام شهر...'/>
                                              <div className='cityValues'>

                                                {
                                                    showCityTbl ? <TableContainer style={{ maxHeight: 80 }} className='tableContainer'>

                                                  <table
                                                    className="table table-condensed"
                                                    style={{ textAlign: "right", padding:'5%' }}
                                                    
                                                  >
                                                    
                                                    <tbody >            
                                                    
                                                      {filteredCity?.map((ct,index) => {
                                                        return (
                                                          <tr key={index} onClick={()=>{
                                                              setValueData(ct.cityName,3);
                                                              setCityID(ct.cityID)
                                                              setCityn(ct.cityName);
                                                              setCityName("");
                                                              setCityName(ct.cityName);


                                                            
                                                          }}>
                                                            <td>{cityID == ct.cityID ? <>&#x2713;</>:<></>}</td>

                                                            <td >
                                                              {ct.cityName}
                                                            </td>
                                                            
                                                          </tr>
                                                        
                                                        );
                                                        })
                                                      }
                                                    
                                                    </tbody>
                                                  </table> 

                                                </TableContainer>
                                                : null
                                                }
                                                

                                              </div>
                                            </div>

            
                  
                                        </div>

                                            </div>
                                          </div>
                                        :
                                        null

                                        }

                                        {
                                            newVersion ? 

                                              <div className='prevPersonForm'>
                                                <div className='row'>
                                                    <div className="col-sm-6 form-group">
                                                            <label htmlFor="duration"> شماره مجله:</label>
                                                            <input type="number" className="form-control" id="name" value={reportTitle}  onChange={(e)=>setReportTitle(e.target.value)} 
                                                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                                    </div>
                                                    <div className="col-sm-6 form-group">
                                                        <label htmlFor="cost"> قیمت هر جلد:</label>
                                                        <input type="number" className="form-control" id="cost" value={cost}  onChange={(e)=>setCost(e.target.value)} 
                                                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                                    </div>
                                                    <div className="col-4 form-group">
                                                        <label htmlFor="number"> تعداد جلد:</label>
                                                        <input type="number" className="form-control" id="number" value={number}  onChange={(e)=>setNumber(e.target.value)} 
                                                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                                                    </div>
                                                </div>
                                              </div>

                                            :
                                            null
                                        }


                                        {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                                        {/* {print ? <Pdf_Viewer show = {print} closeOpenPrint = {closeOpenPrint} printData = {printData} newVersion = {reportTitle} all = {true} /> : null} */}
                                        {/* {printAll ? <Pree_Pdf_Report_All show = {printAll} closeOpenPrintAll = {closeOpenPrintAll} printData = {printData} /> : null} */}
                                        {/* {printAllPersons ? <Pdf_Viewer_All_Person show = {printAllPersons} closeOpenPrintAllPersons = {closeOpenPrintAllPersons} printData = {printData} /> : null} */}
                                      
                                        



                              </div>
                            
                        </div>

                        
                                  <div className='row'>
                                        
                                        <div className='col-1 col-sm-3 col-md-4'></div>
                                        
                                        <Button className='col-10 col-sm-6 col-md-4' onClick={handleDB} autoFocus>
                                          چاپ
                                        </Button>
                                      
                                        <div className='col-1 col-sm-3 col-md-4'></div>

                                    </div>
                      
                    </div>

              </div>

        </div>
       
      );
    }
      
    
   
  }
